var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("SVG Below")]),_vm._v(" "),_c('svg',{attrs:{"width":"100%","height":"100%","version":"1.1","xmlns":"http://www.w3.org/2000/svg"},domProps:{"innerHTML":_vm._s(_vm.getContent())}})])}
var staticRenderFns = []

export { render, staticRenderFns }